import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../App.css";
import "../utils/styles/PageAnimations.css";
import "../css/ContactPage.css";

function ContactPage() {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setError("");
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setError("");

    try {
      const response = await fetch("https://api.onenizer.com/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        const errorMessage =
          data?.errors?.[0]?.msg ||
          data?.message ||
          "Nachricht konnte nicht gesendet werden.";

        setError(errorMessage);
        setStatus("error");
        return;
      }

      setFormData({
        email: "",
        firstName: "",
        lastName: "",
        phone: "",
        subject: "",
        message: "",
      });

      setStatus("success");
    } catch (err) {
      setError("Server nicht erreichbar. Bitte versuche es später erneut.");
      setStatus("error");
    }
  };

  return (
    <div className="contact-page page-animated">
      <h1 className="contact-title animate-up delay-1">{t("contact.title")}</h1>

      <div className="contact-grid">
        <form
          className="contact-form animate-left delay-2"
          onSubmit={handleSubmit}
        >
          <label>
            E-Mail-Adresse *
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              autoComplete="email"
            />
          </label>

          <div className="contact-form-row">
            <label>
              Vorname
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                autoComplete="given-name"
              />
            </label>

            <label>
              Nachname
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                autoComplete="family-name"
              />
            </label>
          </div>

          <label>
            Telefonnummer
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              autoComplete="tel"
            />
          </label>

          <label>
            Betreff
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
            />
          </label>

          <label>
            Nachricht *
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="6"
              required
              minLength="10"
            />
          </label>

          <button type="submit" disabled={status === "loading"}>
            {status === "loading" ? "Wird gesendet..." : "Anfrage senden"}
          </button>

          {status === "success" && (
            <p className="contact-success">
              ✅ Vielen Dank! Deine Nachricht wurde erfolgreich gesendet.
            </p>
          )}

          {status === "error" && <p className="contact-error">❌ {error}</p>}
        </form>

        <div className="contact-info animate-right delay-3 hover-card">
          <h2>{t("contact.subtitle")}</h2>

          <p>{t("contact.description")}</p>

          <div className="contact-info-card hover-card">
            <strong>📧 Email</strong>
            <p>support@onenizer.com</p>
          </div>

          <div className="contact-info-card hover-card">
            <strong>📞 Telefon</strong>
            <p>012 2345 234 23</p>
          </div>

          <div className="contact-info-card hover-card">
            <strong>🕒 Support</strong>
            <p>Montag – Freitag: 9:00 – 18:00 Uhr</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
